import { gql } from '@apollo/client';

export const MENU_QUERY = gql`
    query getAdminMenuOptions($input: MenuInput!) {
        getAdminMenuOptions(input: $input) {
            name
            value
        }
    }
`;